// src/screens/DataDeletionScreen/components/DataDeletion/index.tsx
import { FC, useEffect, useState } from 'react';
import { DataDeletionContainer } from './style';
import StyledButton from 'components/Button'
import FormInputField from 'components/FormInputField'
import PhoneNumberInput from 'components/PhoneNumberInput';
import { colors } from 'constants/colors';
import Checkbox from 'components/Checkbox';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';
import { useSubmitDataDeletionRequest } from 'customHooks/useSubmitDataDeletionRequest';


const DataDeletion: FC = () => {


    const [emailError, setEmailError] = useState(false)
    const [email, setEmail] = useState('')
    const [phoneNumberValidity, setPhoneNumberValidity] = useState(false)
    const [phoneNumberError, setPhoneNumberError] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('')
    const [checked, setChecked] = useState(false);
    const [error, setError] = useState(false);

    const { submitDataDeletionRequest, loading } = useSubmitDataDeletionRequest();


    useEffect(() => {
      if (email.trim().length > 0 || phoneNumber.trim().length > 0) {
        setEmailError(false);
        setPhoneNumberError(false);
      }
    }, [email, phoneNumber]);

    const toggle = () => {
        setChecked((prev) => {
          const value = !prev;
          localStorage.setItem("iUnderstandChecked", value.toString());
          return value;
        });
      
        // Clear checkbox error after user interacts with it
        if (error) {
          setError(false);
        }
      };

      const isValidEmail = (value: string) => {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value.trim());
      };

      useGlobalAlerts();

    return (
        <DataDeletionContainer>
            <div className="background"></div>
            <div className="innerContainer">
                <div className="content">
                    <h1 className="title">Request Deletion of Personal Data</h1>

                    <h2 className="subtitle">Important Notice</h2>

                    <p>Deleting your account is permanent. Once your account is deleted, all associated data, preferences, and history will be permanently removed and cannot be recovered.</p>

                    <h2 className="subtitle">Contact Details</h2>
                    <p>To make a request, please provide either the email address or phone number used on the site. You can include both.</p>
                    <div className='emailFl'>
                        <FormInputField
                            label="EMAIL"
                            inputHeight="48px"
                            borderColor={colors.signInBorderColor}
                            marginBottom="32px"
                            placeholder=""
                            labelWeight="400"
                            width='327px'
                            value={email}
                            error={emailError}
                            errorMessage='Please enter a valid email address and try again.'
                            onChange={(e) => {
                                setEmail(e.target.value)
                            }}
                        />
                    </div>
                    <div className='phoneFl'>
                        <PhoneNumberInput
                            className='phoneNumberInput'
                            label="PHONE"
                            labelPosition='left'
                            error={!phoneNumberValidity && phoneNumberError}
                            errorMessage='Please enter a valid phone number'
                            inputHeight="48px"
                            width='327px'
                            marginBottom={'32px'}
                            labelWeight="400"
                            onChangeNumber={setPhoneNumber}
                            setPhoneNumberValidity={setPhoneNumberValidity}
                            onBlur={() => {
                                // Show error only if user entered something and phone is invalid
                                if (phoneNumber.trim().length > 0 && !phoneNumberValidity) {
                                  setPhoneNumberError(true);
                                }
                                if (emailError) {
                                  setEmailError(false)
                              }
                              }}
                              
                        />
                    </div>
                    <h2 className="subtitle subtitleC">Confirmation</h2>
                    <p>By submitting this request, you confirm that:</p>
                    <ul>
                        <li>You understand this action is irreversible</li>
                        <li>You will lose access to all services associated with this account</li>
                        <li>Your data will be deleted in accordance with our privacy policy</li>
                    </ul>
                    <div>
                    <div className="iUnderstand">
                    <Checkbox
                        checked={checked}
                        error={error}
                        borderColor={colors.signInBorderColor}
                        onChange={toggle}
                        checkboxScale={1.5}
                    />
                    I understand this action is permanent and authorize the website controller to contact me to verify and process this request.

                    </div>
                    {error && (
                            <div className="requiredCh">Please confirm statement above and try again.</div>
                    )}

                    </div>
                    <div className='submitRButton'>
                        <StyledButton
                            width="173px"
                            fontSize={16}
                            height="48px"
                            disabled={loading}
                            onClick={() => {
                              let hasError = false;
                            
                              const trimmedEmail = email.trim();
                              const trimmedPhone = phoneNumber.trim();
                            
                              const hasEmail = Boolean(trimmedEmail);
                              const hasPhone = Boolean(trimmedPhone);
                            
                              // checkbox required
                              if (!checked) {
                                setError(true);
                                hasError = true;
                              }
                            
                              // at least one contact required
                              if (!hasEmail && !hasPhone) {
                                setEmailError(true);
                                setPhoneNumberError(true);
                                hasError = true;
                              }
                            
                              // validate email only if entered
                              if (hasEmail && !isValidEmail(trimmedEmail)) {
                                setEmailError(true);
                                hasError = true;
                              }
                            
                              // validate phone only if entered
                              if (hasPhone && !phoneNumberValidity) {
                                setPhoneNumberError(true);
                                hasError = true;
                              }
                            
                              if (hasError) return;
                            
                              submitDataDeletionRequest(
                                hasEmail ? trimmedEmail : undefined,
                                hasPhone ? trimmedPhone : undefined
                              );
                            }}
                        >
                            Submit Request
                        </StyledButton>
                    </div>
                </div>
            </div>
        </DataDeletionContainer>
    )
}

export default DataDeletion;